import React from 'react';
import { CheckCircle2, Mail, Download, Moon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function ThankYouPage() {
  return <div className="min-h-screen flex flex-col bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-583" data-mp="2p9z0hw0njt9l">
      <main className="flex-grow flex items-center justify-center py-16 px-4" data-id="element-584" data-mp="2zahrdaqmwa10">
        <div className="max-w-3xl w-full mx-auto text-center" data-id="element-585" data-mp="2z8ese17i76k5">
          {/* Success Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-success/10 mb-8" data-id="element-586" data-mp="3d3pgmvr8stfj">
            <CheckCircle2 size={48} className="text-success" data-id="element-587" data-mp="3mzskc61qt04l" />
          </div>

          {/* Headlines */}
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-forest mb-6" data-id="element-588" data-mp="3i0pn37s07y76">
            ¡Felicidades! Tu Pedido Está Confirmado
          </h1>
          <p className="text-xl md:text-2xl text-dark/80 font-medium mb-12" data-id="element-589" data-mp="1sm1cnc2z4qbs">
            Tu acceso completo ha sido enviado a tu correo electrónico.
          </p>

          {/* Next Steps Card */}
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-warm border border-gold/20 text-left mb-12 relative overflow-hidden" data-id="element-590" data-mp="3mugtpx1ljb8q">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-forest via-gold to-forest" data-id="element-591" data-mp="3vtkct10rjqn8"></div>

            <h2 className="font-serif text-2xl md:text-3xl font-bold text-forest mb-8 text-center" data-id="element-592" data-mp="4f64st0mp7s0">
              Tus Próximos Pasos:
            </h2>

            <div className="space-y-8" data-id="element-593" data-mp="9fty5lcby0pe">
              {/* Step 1 */}
              <div className="flex items-start gap-6" data-id="element-594" data-mp="ebj01vbtntov">
                <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-595" data-mp="jc6pickek2gz">
                  <Mail size={24} className="text-forest" data-id="element-596" data-mp="ne0ma9rh8mbv" />
                </div>
                <div data-id="element-597" data-mp="2l3a3nbti3z6a">
                  <h3 className="text-xl font-bold text-dark mb-2" data-id="element-598" data-mp="2l41y2jbd3quz">
                    1. Revisa tu bandeja de entrada
                  </h3>
                  <p className="text-dark/70 leading-relaxed" data-id="element-599" data-mp="2p55bz09unctk">
                    Busca un correo de Hotmart con el asunto "Tu acceso a Cenas
                    Anti-Inflamatorias". Si no lo ves en 5 minutos, revisa tu
                    carpeta de spam o promociones.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-6" data-id="element-600" data-mp="1988xzvy6dqa">
                <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-601" data-mp="1buig52ef3b5">
                  <Download size={24} className="text-forest" data-id="element-602" data-mp="aafxvrckq27p" />
                </div>
                <div data-id="element-603" data-mp="a8btz9eod37f">
                  <h3 className="text-xl font-bold text-dark mb-2" data-id="element-604" data-mp="ozkgvar70agv">
                    2. Descarga tu material
                  </h3>
                  <p className="text-dark/70 leading-relaxed" data-id="element-605" data-mp="k1ak4vptl1t5">
                    Accede a la plataforma y descarga tu Guía Maestra, el
                    Recetario de 21 Cenas y todos tus bonos exclusivos.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-6" data-id="element-606" data-mp="1cnr0r75vxbhr">
                <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-607" data-mp="1hlafs9aepsar">
                  <Moon size={24} className="text-forest" data-id="element-608" data-mp="13mavtexua1kx" />
                </div>
                <div data-id="element-609" data-mp="17n32q1j8nue1">
                  <h3 className="text-xl font-bold text-dark mb-2" data-id="element-610" data-mp="17ml8fag4zq8r">
                    3. Comienza esta misma noche
                  </h3>
                  <p className="text-dark/70 leading-relaxed" data-id="element-611" data-mp="tun7vo0hr2o7">
                    Elige una receta rápida del recetario, aplica el Método de
                    Digestión en Reposo y prepárate para despertar diferente
                    mañana.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Support Section */}
          <div className="bg-forest/5 rounded-xl p-6 border border-forest/10" data-id="element-612" data-mp="ayeyq94cy7nm">
            <p className="text-dark/80 font-medium" data-id="element-613" data-mp="fwgi6v5p48zm">
              ¿Tienes algún problema con tu acceso?
            </p>
            <p className="text-dark/60 mt-2" data-id="element-614" data-mp="7u65f1imi88i">
              Escríbenos a{' '}
              <a href="mailto:soporte@ejemplo.com" className="text-forest font-bold hover:underline" data-id="element-615" data-mp="2w4lkeddi4vz">
                soporte@ejemplo.com
              </a>{' '}
              y te ayudaremos de inmediato.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-616" data-mp="3q7noutkprxit" />
    </div>;
}